import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { feedbackHandlingMiddleware } from "./middleware/feedbackHandling";
import { handleCancelActionMiddleware } from "./middleware/handleCancelActionMiddleware";
import { handleCorrectionModeActionMiddleware } from "./middleware/handleCorrectionModeActionMiddleware";
import { preventToggleTaskDetailsMiddleware } from "./middleware/preventToggleTaskDetailsHandling";
import { setValidateNextAfterLoadingOrSavingMiddleware } from "./middleware/setValidateNextAfterLoadingOrSavingMiddleware";
import { customCompleteTaskSaga } from "./saga/customCompleteTaskSaga";
import { customProceedSaga } from "./saga/customProceedSaga";
import { customSaveSaga } from "./saga/customSaveSaga";
import { processSaveFailedSaga } from "./saga/processSaveFailedSaga";

/**
 * Client Modul für grundlegende Workflow
 * Funktionaltitäten (e.g. Notification wenn
 * ein Prozess gestartet wurde)
 */
const workflowsModule = (): Module => ({
	id: "WorkflowsModule",
	middlewares: () => [
		feedbackHandlingMiddleware,
		setValidateNextAfterLoadingOrSavingMiddleware,
		handleCorrectionModeActionMiddleware,
		handleCancelActionMiddleware,
		preventToggleTaskDetailsMiddleware
	],
	sagas: () => [customCompleteTaskSaga, customSaveSaga, customProceedSaga, processSaveFailedSaga]
});

export default workflowsModule;
